export default "__VITE_ASSET__iZg5gRe3__"